export default __webpack_public_path__ + "72ccfccf1733890f6a3e7a9dcaf77164.png";